import React from 'react'
import styled from '@emotion/styled'
import { array } from 'prop-types'
import { DetailedCard } from './DetailedCard'
import { OurMission } from './OurMission'

const Wrapper = styled.div`
	background-color: ${({ theme }) => theme.colors.white};
	display: flex;
	flex-direction: column;
	grid-gap: 1rem;
	justify-content: center;
	margin: 0 auto;
	width: 95%;

	${({ theme }) => theme.MQ.L} {
		flex-direction: row;
		${({ theme }) => theme.maxWidth.L};
	}
`
const ServicesContainer = styled.div`
	align-items: center;
	display: flex;
	flex-direction: column;
	justify-content: center;
	width: 100%;
`

ServicesSection.propTypes = {
	services: array,
}

/**
 * Service for Top Five QT Landing Page Template
 * Consists of hero background image, subtitle, and title
 *
 * @param {Array} props.services - array of services
 */
export function ServicesSection({ services }) {
	return (
		<Wrapper id="services">
			<ServicesContainer>
				{services.map((service, index) => (
					<DetailedCard key={index} service={service} />
				))}
			</ServicesContainer>
			<OurMission />
		</Wrapper>
	)
}
